var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('div',{staticClass:"container-fluid",staticStyle:{"min-height":"60vh"}},[_vm._t("default")],2),_c('Footer'),_c('CookieModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }